import apiClient from '../axios';

export default {
    getObtenerSesionesPorUsuario(id) {
        return apiClient.get(`/sesiones/usuario/${id}`);
    },
};